module.exports = __webpack_public_path__ + "/images/shop/carpage-car-selection/help_caris_FR2.jpg";